import React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import { ImgTimeTaken } from "./Images/ImgTimeTaken.tsx";
import type { Message } from "../models.ts";

export interface MessageStatsProps {
  message: Message;
}

@observer
export class MessageStats extends React.Component<MessageStatsProps> {
  @observable private _showTimeTakenPopup: boolean = false;

  componentDidMount() {
    document.addEventListener('click', this._onDocumentClickTimeTaken);
  }


  componentWillUnmount(): void {
    document.removeEventListener('click', this._onDocumentClickTimeTaken);
  }

  render() {
    const { message } = this.props;
    
    const timeSec = (message.timeTaken || 0) / 1_000_000_000;
    const thinkSec = message.thinkingTimeTaken != null ? message.thinkingTimeTaken / 1000 : null;
    const genSec = thinkSec != null ? Math.max(0, timeSec - thinkSec) : timeSec;
    const tps = (message.tokensOut && genSec > 0) ? (message.tokensOut / genSec) : null;

    return (
      <span className="message-time-taken message-time-taken--clickable" onClick={this._onTimeTakenClick}>
        <ImgTimeTaken size={12} /> {timeSec.toFixed(1)}s
        {this._showTimeTakenPopup && (
          <div className="tc-popup tt-popup" onClick={e => e.stopPropagation()}>
            <div className="tc-popup-title">Response stats</div>
            {tps != null && (
              <div className="tc-popup-row">
                <span className="tc-popup-label">Tokens / sec</span>
                <span className="tc-popup-value tt-value-highlight">{tps.toFixed(1)}</span>
              </div>
            )}
            <div className="tc-popup-row">
              <span className="tc-popup-label">Total time</span>
              <span className="tc-popup-value">{timeSec.toFixed(2)}s</span>
            </div>
            {thinkSec != null && (
              <div className="tc-popup-row">
                <span className="tc-popup-label">Thinking time</span>
                <span className="tc-popup-value">{thinkSec.toFixed(2)}s</span>
              </div>
            )}
            {thinkSec != null && (
              <div className="tc-popup-row">
                <span className="tc-popup-label">Generation time</span>
                <span className="tc-popup-value">{genSec.toFixed(2)}s</span>
              </div>
            )}
            {message.tokensIn != null && (
              <div className="tc-popup-row">
                <span className="tc-popup-label">Tokens in</span>
                <span className="tc-popup-value">{message.tokensIn.toLocaleString()}</span>
              </div>
            )}
            {message.tokensOut != null && (
              <div className="tc-popup-row">
                <span className="tc-popup-label">Tokens out</span>
                <span className="tc-popup-value">{message.tokensOut.toLocaleString()}</span>
              </div>
            )}
            {message.tokensIn != null && message.tokensOut != null && (
              <div className="tc-popup-row">
                <span className="tc-popup-label">Total tokens</span>
                <span className="tc-popup-value">{(message.tokensIn + message.tokensOut).toLocaleString()}</span>
              </div>
            )}
          </div>
        )}
      </span>
    );
  }
  
  @action.bound
  private _onTimeTakenClick(e: React.MouseEvent) {
    e.stopPropagation();
    this._showTimeTakenPopup = !this._showTimeTakenPopup;
  }
  
  @action.bound
  private _onDocumentClickTimeTaken() {
    if (this._showTimeTakenPopup) this._showTimeTakenPopup = false;
  }
}
